/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_RussianInputs */



/**
* | output |
* | --- |
* | "Russian" |
*
* @param {Speechmatics_Target_Language_RussianInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_russian = /** @type {((inputs?: Speechmatics_Target_Language_RussianInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_RussianInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Russe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Russisch")
	if (locale === "it") return /** @type {LocalizedString} */ ("russo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Русский")
	if (locale === "es") return /** @type {LocalizedString} */ ("ruso")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("俄语")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ロシア")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रूसी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("russo")
	return /** @type {LocalizedString} */ ("Russian")
});